import { CircleCheck } from "lucide-react"

import { Badge, cn } from "@atlant/ui"

const statusConfig = {
  healthy: {
    label: "Healthy",
    className: "bg-green-50 text-green-700 border-green-200",
    icon: CircleCheck,
  },
  warning: {
    label: "Warning",
    className: "bg-yellow-50 text-yellow-700 border-yellow-200",
    icon: CircleCheck,
  },
  critical: {
    label: "Critical",
    className: "bg-red-50 text-red-700 border-red-200",
    icon: CircleCheck,
  },
} as const

interface FleetStatusBadgeProps {
  status: "healthy" | "warning" | "critical"
}

export const FleetStatusBadge = ({ status }: FleetStatusBadgeProps) => {
  const config = statusConfig[status]
  const Icon = config.icon

  return (
    <Badge
      variant="outline"
      className={cn("gap-1 px-2 py-0.5 font-medium", config.className)}
    >
      <Icon className="size-3.5" />
      {config.label}
    </Badge>
  )
}
